import Cookies from 'js-cookie'

const TokenKey = 'CodeStoreAdminToken'
const UserInfoKey = 'CodeStoreAdminUserInfoKey'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  const rememberMe = Cookies.get('rememberMe')
  if (rememberMe) {
    Cookies.set(TokenKey, token, { expires: 90 })
  } else {
    Cookies.set(TokenKey, token)
  }
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getUserInfo () {
  const result = Cookies.get(UserInfoKey)
  return result ? JSON.parse(result) : {}
}

export function setUserInfo (data) {
  const user = data ? JSON.stringify(data) : ''
  const rememberMe = Cookies.get('rememberMe')
  if (rememberMe) {
    Cookies.set(UserInfoKey, user, { expires: 90 })
  } else {
    Cookies.set(UserInfoKey, user)
  }
}

export function removeUserInfo () {
  return Cookies.remove(UserInfoKey)
}
